import { createRouter, createWebHistory } from "vue-router";
import Itineraries from "@/pages/Itineraries.vue";
import Campaigns from "@/pages/Campaigns.vue";
import MuseumPremialitaA from "@/pages/MuseumPremialitaA.vue";
import MuseumPremialitaB from "@/pages/MuseumPremialitaB.vue";

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes: [
    {
      path: "/",
      redirect: "/login",
    },
    {
      path: "/itineraries",
      name: "Itineraries",
      component: Itineraries,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/campaigns",
      name: "Campaigns",
      component: Campaigns,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/museum-premiality-type-a",
      name: "Type A Museum Premiality",
      component: MuseumPremialitaA,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/museum-premiality-type-b",
      name: "Type B Museum Premiality",
      component: MuseumPremialitaB,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/login",
      name: "Login",
      component: () => import("@/pages/Login.vue"),
    },
  ],
});

router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    let token = JSON.parse(localStorage.getItem("mi_cms-tokens"))?.access;
    if (!token) {
      next({ name: "Login" });
    } else {
      next();
    }
  }
  next();
});

export default router;
